/* titanore-boot sitewide4 — loads sitewide sticky ATC */
(function () {
  try {
    if (window.__tgemSiteStickyBoot) return;
    if (document.querySelector('script[src*="titanore-sitewide-atc.js"]')) return;
    var s = document.createElement('script');
    var v = 'sitewide6-cta';
    s.src = (window.Shopify && Shopify.cdnHost)
      ? ('https://' + Shopify.cdnHost + '/s/files/1/1009/4254/5283/t/9/assets/titanore-sitewide-atc.js?v=' + v)
      : ('https://cdn.shopify.com/s/files/1/1009/4254/5283/t/9/assets/titanore-sitewide-atc.js?v=' + v);
    s.defer = true;
    s.setAttribute('data-tl-sticky-boot', '1');
    (document.head || document.documentElement).appendChild(s);
  } catch (e) {}
})();
